export default __webpack_public_path__ + "static/media/check.8c8c4bc1.png";